import Moment from "react-moment";
import { GrNotes } from "react-icons/gr";
import { CgProfile } from "react-icons/cg";
import { BsChatLeft } from "react-icons/bs";
import { useState, useEffect } from "react";
import { TfiInfoAlt } from "react-icons/tfi";
import { CiViewTimeline } from "react-icons/ci";
import ContactSMS from "./Componants/ContactSMS";
import ContactNotes from "./Componants/ContactNotes";
import dayjs from "dayjs";
import { Card, Dropdown, Form } from "react-bootstrap";
import ContactTickets from "./Componants/ContactTickets";
import ContactTimelines from "./Componants/ContactTimelines";
import ContactConversations from "./Componants/ContactConversations";
import { contactServices } from "../../APIServices/SitePilotManagement/contactServices";
import { FiBell, FiChevronDown } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { formatTime } from "../../APIHelpers/utils";
import { inboxServices } from "../../APIServices/SitePilotManagement/inboxServices";

const InfoRow = ({ label, value }) => (
  <div className="hstack justify-content-between py-1">
    <span className="text-muted">{label}</span>
    <span className="fw-medium text-end">{value || "-"}</span>
  </div>
);

const SocialRow = ({ label, value }) => (
  <div className="hstack justify-content-between py-1">
    <span className="text-muted">{label}</span>
    {value && value !== "-" ? (
      <a
        href={value}
        target="_blank"
        rel="noopener noreferrer"
        className="fw-medium text-end"
      >
        {value}
      </a>
    ) : (
      <span className="fw-medium">-</span>
    )}
  </div>
);

const ContactDetails = ({ contactId, currentUserData }) => {
  const [view, setView] = useState("profile");
  const [openHistory, setOpenHistory] = useState("timeline");
  const [contactData, setContactData] = useState("");
  const [notifications, setNotifications] = useState([]);
  const getSingleContact = async () => {
    let data = await contactServices.getSingleContact(contactId)
    setContactData(data?.data || "")
  }
  const getNotificationByCustomer = async () => {
    let data = await inboxServices.getNotificationByCustomer(contactData?.inboxId || null)
    setNotifications(data?.data || "")
  }

  const MoreActionOption = [
    {
      label: "Twilio SMS",
      icon: <CiViewTimeline />,
    },
    {
      label: "Ticket",
      icon: <BsChatLeft />,
    },
    {
      label: "WhatsApp",
      icon: <FaWhatsapp />,
    }
  ];

  useEffect(() => {
    if (contactId) {
      getSingleContact()
    }
  }, [contactId]);
  
  useEffect(() => {
    if (contactData) {
      getNotificationByCustomer()
    }
  }, [contactData]);

  const getChatDateLabel = (date) => {
    const msgDate = dayjs(date);
    const today = dayjs();
    if (msgDate.isSame(today, "day")) {
      return "Today";
    }
    if (msgDate.isSame(today.subtract(1, "day"), "day")) {
      return "Yesterday";
    }
    if (msgDate.isSame(today, "week")) {
      return msgDate.format("dddd");
    }
    return msgDate.format("dddd, DD MMM YYYY");
  };

  return (
    <>
      <div className="d-flex">
        <div className={`overflow-auto border-end`} style={{ height: "calc(100vh - 108px)", width: "40%" }}>
          <Card className="border-0">
            <Card.Body className="p-0 d-flex flex-column">
              <div className="preview-header">
                <div className="avatar-lg">{contactData?.name?.charAt(0)}</div>
                <h6 className="mb-0">{contactData?.name}</h6>
                <small className="text-muted">{contactData?.email}</small>
              </div>
              <div className="preview-switcher">
                <button
                  className={`hstack gap-2 justify-content-center ${view === "profile" && "active"}`}
                  onClick={() => setView("profile")}
                >
                  <CgProfile /> Profile
                </button>
                <button
                  className={`hstack gap-2 justify-content-center ${view === "notification" && "active"}`}
                  onClick={() => setView("notification")}
                >
                  <FiBell /> Notification
                </button>
              </div>
              <div className="preview-scroll overflow-auto" style={{ height: `calc(100vh - 294px)` }}>
                {view === "profile" && (
                  <div className="preview-block">
                    <Form.Label>Activity Info</Form.Label>
                    <InfoRow label="Total Page View" value={contactData?.totalPageView} />
                    <InfoRow label="Total Session" value={contactData?.totalSession} />
                    <InfoRow label="Total Chat" value={contactData?.totalMessage} />
                    <InfoRow label="Total Notification" value={contactData?.totalNotification} />
                    <InfoRow label="Total Note" value={contactData?.totalNote} />

                    <hr />
                    <Form.Label>Customer Info</Form.Label>
                    <InfoRow label="Name" value={contactData?.name} />
                    <InfoRow label="Email" value={contactData?.email} />
                    <InfoRow label="Phone" value={contactData?.phone} />
                    <InfoRow label="Company Name" value={contactData?.companyName} />
                    <InfoRow label="Country" value={contactData?.countryName} />
                    <InfoRow label="Address" value={contactData?.address} />
                    {(contactData?.additionalInfo || [])?.map((item, index) => (
                      <InfoRow key={index} label={item?.label} value={item.value} />
                    ))}
                    {(contactData?.social || [])?.map((item, index) => (
                      <SocialRow key={index} label={item?.title} value={item.url} />
                    ))}
                    <InfoRow
                      label="Created"
                      value={
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {contactData?.createdAt}
                        </Moment>
                      }
                    />
                  </div>
                )}
                {view === "notification" && (
                  <div className="preview-block">
                    {notifications?.map((item, i) => {
                      const currentLabel = getChatDateLabel(item.createdAt);
                      const prevLabel =
                        i > 0 ? getChatDateLabel(notifications[i - 1].createdAt) : null;
                      const showDateDivider = i === 0 || currentLabel !== prevLabel;
                      return (
                        <>
                          {showDateDivider && (
                            <div
                              className={`text-center ${i === 0 ? "mb-3" : (i + 1) === notifications?.length ? "mt-3" : "my-3"}`}>
                              <span
                                className="px-3 py-1 rounded bg-light text-muted"
                                style={{ fontSize: 12 }}
                              >
                                {currentLabel}
                              </span>
                            </div>
                          )}
                          <div className="d-flex gap-2 w-100 mb-3">
                            <FiBell className="mt-2" />
                            <div className="p-2 gap-2 bg-light rounded w-100 d-flex justify-content-between align-items-end" style={{ fontSize: 12, borderLeft: "3px solid #0d6efd" }}>
                              {item.type === "navigate" ?
                                <span>Visitor has Navigated to the <a href={item.pageURL} target="__blank">{item.pageName}</a> page.</span>
                                :
                                <span>{item.message}</span>
                              }
                              <span className="text-nowrap"
                                style={{
                                  fontSize: 11,
                                  color: "#6c757d",
                                  marginTop: 2,
                                }}
                              >
                                {formatTime(item.createdAt)}
                              </span>
                            </div>
                          </div>
                        </>
                      )
                    })}
                  </div>
                )}
                {view === "more" && (
                  <div className="preview-block">

                  </div>
                )}
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="w-100">
          <div className="preview-switcher gap-2">
            <button
              className={`flex-fill hstack gap-2 justify-content-center ${openHistory === "timeline" ? "active" : ""
                }`}
              onClick={() => setOpenHistory("timeline")}
            >
              <CiViewTimeline /> Timeline
            </button>

            <button
              className={`flex-fill hstack gap-2 justify-content-center ${openHistory === "conversations" ? "active" : ""
                }`}
              onClick={() => setOpenHistory("conversations")}
            >
              <BsChatLeft /> Conversations
            </button>

            <button
              className={`flex-fill hstack gap-2 justify-content-center ${openHistory === "note" ? "active" : ""
                }`}
              onClick={() => setOpenHistory("note")}
            >
              <GrNotes /> Note
            </button>

            <Dropdown className="flex-fill">
              <Dropdown.Toggle
                as="button"
                className={`hstack gap-2 justify-content-center ${MoreActionOption.some(item => item.label === openHistory) ? "active" : ""
                  }`}
                style={{ width: "-webkit-fill-available" }}
              >
                {MoreActionOption.find(item => item.label === openHistory)?.icon} {MoreActionOption.some(item => item.label === openHistory) ? openHistory : "More"}
                <FiChevronDown />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {MoreActionOption.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    className="hstack gap-2"
                    onClick={() => {
                      setOpenHistory(item.label);
                    }}
                    active={openHistory === item.label}
                  >
                    {item.icon} {item.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className={`overflow-auto`} style={{ height: "calc(100vh - 152px)" }}>
            <Card className="border-0">
              <Card.Body className="p-0 d-flex flex-column">
                <div className="preview-scroll">
                  {openHistory === "timeline" && (
                    <ContactTimelines
                      inboxId={contactData?.inboxId}
                      currentUserData={currentUserData}
                      contactId={contactId}
                    />
                  )}
                  {openHistory === "conversations" && (
                    <ContactConversations
                      inboxId={contactData?.inboxId}
                      currentUserData={currentUserData}
                      contactId={contactId}
                    />
                  )}
                  {openHistory === "note" &&
                    <ContactNotes
                      contactId={contactId}
                      currentUserData={currentUserData}
                    />}
                  {openHistory === "Twilio SMS" && (
                    <ContactSMS />
                  )}
                  {openHistory === "Ticket" && (
                    <ContactTickets />
                  )}
                  {openHistory === "WhatsApp" && (
                    <ContactTickets />
                  )}
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactDetails;
